export default "__VITE_ASSET__a6cd2192__"